import { tt } from "../i18n/i18n";
import { CreateErrorOptions, ValidationError } from "yup";
import validateInternationalPhone from "./validateInternationalPhone";

export default function (
  path: string,
  value: string,
  createError: (params?: CreateErrorOptions) => ValidationError
) {
  //
  // Given
  //
  if (!value) {
    return createError({
      path,
      message: tt("validPhoneNumberMessage")
    });
  }

  //
  // When: Validate phone number
  //
  const isValid = validateInternationalPhone(value);

  //
  // Then
  //
  if (!isValid) {
    return createError({
      path,
      message: tt("validPhoneNumberMessage")
    });
  }

  return true;
}
